// features/products/packageImage.ts
//
// Ảnh minh hoạ MỘT GÓI cho bộ chọn sản phẩm của form đơn.
//
// Thứ tự ưu tiên chép ĐÚNG luật của trang đặt lịch khách
// (backend/internal/core/customerbooking/public_service_images.go):
//
//   1) ảnh bìa CONCEPT đầu tiên của gói có ảnh   ← nguồn chính
//   2) ảnh bìa của concept TRÙNG MÃ GÓI          ← thương hiệu kiểu gói (GNCA)
//   3) products.image_url — ảnh riêng gán ở hộp Thêm/Sửa gói
//
// Vì sao concept đứng trước ảnh riêng: sửa ảnh ở trang "Concept & Trang phục"
// là mọi màn đổi theo, không ai phải đi gán lại ảnh cho từng gói. Đảo thứ tự
// này là cùng một gói hiện hai ảnh khác nhau ở form đơn và ở trang khách.
//
// KHÔNG mượn ảnh của gói kề (trang khách cũng đã bỏ mượn, CEO chốt 3a 03/10/2026): ở đây người xem là sale đang chốt
// tiền với khách, ảnh mượn của gói khác dẫn tới tư vấn sai gói. Không có ảnh
// thì nói thẳng là chưa có.
//
// Đầu ra là giá trị thô (base_path của kho ảnh HOẶC URL đầy đủ) — phía gọi
// bọc qua lib/upload imageUrl() để chọn biến thể.

import type { PickerProduct } from "./packageOptions";

/** Mã concept → ảnh bìa (base_path hoặc URL). Thiếu khoá = concept chưa có ảnh. */
export type ConceptCoverMap = Readonly<Record<string, string | undefined>>;

export function packageImageOf(
  product: PickerProduct | null | undefined,
  covers: ConceptCoverMap,
): string | undefined {
  if (!product) return undefined;
  for (const conceptId of product.concepts ?? []) {
    const cover = covers[conceptId];
    if (cover) return cover;
  }
  return covers[product.id] || product.imageUrl || undefined;
}
